import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../../base/baseGet.args'

@ArgsType()
export class MessageThreadGetArgs extends BaseGetArgs<MessageThreadGetArgs> {
  @Field(t => Int, { nullable: true })
  state?: number

  @Field({ nullable: true })
  needle?: string

  @Field(t => Int, { nullable: true })
  reviewUserId?: number
}
